import React, { forwardRef, useCallback } from 'react'
import { useField } from 'formik'
import emojiRegex from 'emoji-regex'
import InputCharacterCounter from './InputCharacterCounter'
import { TextInputContainer } from './styles'
import Icon from 'components/Icon/Icon'
import TextReadOnly from './ReadyOnly/TextReadOnly'

export type TextInputIconPosition = 'left' | 'right'

interface TextInputProps extends React.HTMLProps<HTMLInputElement> {
    name: string
    isRequired?: boolean
    showInputLength?: boolean
    maxInputLength?: number
    placeholder: string
    width?: string
    isDisable?: boolean
    isShowTooltip?: boolean
    toolTipContent?: string | Function // eslint-disable-line @typescript-eslint/ban-types
    isShowError?: boolean
    isError?: boolean
    iconPosition?: TextInputIconPosition
    IconComponent?: React.ReactElement
    isReadOnly?: boolean
}

const TextInput = forwardRef<any, TextInputProps>(function TextInput(
    {
        width,
        isDisable = false,
        isRequired,
        showInputLength = false,
        placeholder,
        maxInputLength = 100,
        isShowTooltip = false,
        isShowError = true,
        isError = false,
        iconPosition = 'right',
        IconComponent,
        isReadOnly = false,
        ...props
    },
    ref,
) {
    const [field, meta] = useField(props.name)
    const hasError = Boolean(meta.touched && meta.error) || isError

    const getInputCharLength = useCallback(() => {
        const regex = emojiRegex()
        if (meta && meta.value) {
            const emojiArr = meta.value.match(regex)
            if (emojiArr != null) {
                return meta.value.length - emojiArr.length
            } else {
                return meta.value.length
            }
        } else {
            return 0
        }
    }, [meta])
    return (
        <>
            {isReadOnly ? (
                <TextReadOnly value={Boolean(field.value) ? field.value : ''} />
            ) : (
                <TextInputContainer width={width}>
                    <div
                        className={`input-area-container input-area ${isDisable ? 'disable' : ''} ${
                            hasError ? 'error-border' : ''
                        }`}
                    >
                        <div className="input-box">
                            {iconPosition === 'left' && IconComponent ? IconComponent : null}
                            <input
                                {...props}
                                {...field}
                                value={Boolean(field.value) ? field.value : ''}
                                ref={ref}
                                required={isRequired}
                                placeholder={placeholder}
                                disabled={isDisable}
                            />
                            {isDisable && isShowTooltip && <Icon.QuestionMarkIcon />}
                            {iconPosition === 'right' && IconComponent ? IconComponent : null}
                        </div>
                    </div>
                    <div className="text-area">
                        <div className="error">{isShowError && hasError && meta.error}</div>
                        {showInputLength && (
                            <div className="counter">
                                <InputCharacterCounter
                                    inputCharLength={getInputCharLength()}
                                    maxInputLength={maxInputLength}
                                />
                            </div>
                        )}
                    </div>
                </TextInputContainer>
            )}
        </>
    )
})
export default TextInput
